import React from 'react';
import { toolkit } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function Toolkit() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="toolkit-title" data-id="element-286" data-mp="1yfelmwrqbmzg">
      <div className="mx-auto max-w-5xl" data-id="element-287" data-mp="23e812uqkto29">
        <SectionHeading eyebrow="Also included" title={<span id="toolkit-title" data-id="element-289" data-mp="27g30ftoy5rde">The Complete Clinical Route Toolkit</span>} subtitle="30+ practical tools you can use while moving through real cases." data-id="element-288" data-mp="23f9bcwzrq6ix" />

        <ul className="mt-12 grid gap-x-8 gap-y-7 sm:grid-cols-2 lg:grid-cols-4" data-id="element-290" data-mp="2ccteycl3sewp">
          {toolkit.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 sm:flex-col sm:gap-3" data-id="element-291" data-mp="2m4z65k3j6sau">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-soft text-brand" data-id="element-292" data-mp="2r3sn5mi111fr">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-293" data-mp="2v4vx5sde8392" />
              </span>
              <div data-id="element-294" data-mp="20wa3r4rptof5">
                <h3 className="text-lg font-bold text-ink" data-id="element-295" data-mp="20wtkii5mq6rl">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-296" data-mp="1vxgop7ws5pcv">{text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-xl font-bold leading-snug text-brand-dark sm:text-2xl" data-id="element-297" data-mp="1qz5dasqu76sj">
          Any complex sensory case can feel easier to navigate when you don’t have to reinvent the process every time.
        </p>

        <div className="mt-10" data-id="element-298" data-mp="2eo87f02nqs3x">
          <CTAButton label="I want the complete system" data-id="element-299" data-mp="2ep9gx040z6jj" />
        </div>
      </div>
    </section>;
}